import React, { useEffect, useState } from "react";
import { getBlogs } from "../services/blogService";
import getOptimizedUrl from '../utils/imageUtils';
import { useNavigate } from "react-router-dom";
import HomeMobileNavbar from "../components/HomeMobileNavbar";
import Navbar from "../components/Navbar";

const fmtDate = (iso) => {
  try {
    const d = new Date(iso);
    return new Intl.DateTimeFormat("en-GB", {
      day: "numeric",
      month: "short",
      year: "2-digit",
    }).format(d);
  } catch (e) {
    return "";
  }
};

const Blogs = () => {

    const [windowWidth, setWindowWidth] = React.useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState("grid"); // 'list' or 'grid'
  const isPhoneView = windowWidth < 768;
  const effectiveView = isPhoneView ? "grid" : view;
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    getBlogs()
      .then((data) => {
        if (!mounted) return;
        setBlogs(data || []);
      })
      .catch((e) => console.error("Failed to load blogs", e))
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  if (loading)
    return <div className="w-full py-20 text-center font-bdogrotesk">Loading blogs...</div>;

  return (
    <div>
       {windowWidth < 1168 ? <HomeMobileNavbar /> : <Navbar />}
    <div className="px-4 py-8 mx-auto font-bdogrotesk">
      <div className="flex items-center border-solid pb-3 border-b-2 border-black justify-between mb-3">
        <div className="text-base text-black font-bdogrotesk">All Blogs</div>
        <div className="text-base font-bdogrotesk hidden md:block">
          <button
            onClick={() => setView("grid")}
            className={`px-1 py-1 ${
              effectiveView === "grid" ? "font-semibold" : "text-gray-500"
            }`}
          >
            Grid
          </button>
          <button
            onClick={() => setView("list")}
            className={`px-1 py-1 ${
              effectiveView === "list" ? "font-semibold" : "text-gray-500"
            }`}
            style={{ display: isPhoneView ? "none" : "inline-block" }}
          >
            List
          </button>
        </div>
      </div>

      {effectiveView === "list" ? (
        <div className="space-y-0">
          {blogs.map((b) => (
            <div key={b._id} className="relative border-b border-black py-8 flex flex-col lg:flex-row items-start lg:items-stretch gap-5 lg:pr-40">
              <div className="w-full lg:w-7/12 flex flex-col justify-between lg:min-h-[22rem]">
                <h2 className="text-4xl md:text-6xl font-bold leading-tight text-black">
                  {b.title}
                  {b.subtitle && (
                  <div className="text-base text-gray-700 font-bdogrotesk font-medium mt-2">
                    {b.subtitle}
                  </div>
                )}
                </h2>
                
                <div className="mt-14 text-sm flex items-center">
                  <span
                    onClick={() => navigate(`/blog/?blog=${b._id}`)}
                    className="cursor-pointer font-semibold text-sm text-black"
                  >
                    Read Now
                  </span>
                  <span className="ml-4 text-sm text-gray-500">{(b.readingTime || 5) + ' min'}</span>
                </div>
              </div>
              <div className="w-full lg:w-2/12 flex justify-center lg:py-2">
                <div className="w-36 md:w-full aspect-[3/4] bg-gray-100 overflow-hidden self-stretch">
                  {b.images && b.images[0] ? (
                    <img
                      src={getOptimizedUrl(b.images[0] || '', 1200)}
                      alt={b.title}
                      className="w-full h-full object-cover"
                    />
                  ) : null}
                </div>
              </div>
              <div className="absolute right-0 top-8 hidden lg:block text-left text-base text-gray-500 w-56">
                <div className="line-clamp-6 overflow-hidden"><span className="text-black font-medium">{fmtDate(b.createdAt)}</span> | {b.previewSnippet || b.intro || b.excerpt}</div>
                {/* <div className="mt-2 text-right">{b.author || "Admin"}</div> */}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex flex-wrap -mx-3 font-bdogrotesk">
          {blogs.map((b) => (
            <div key={b._id} className="mb-6 w-full sm:w-1/2 lg:w-1/3">
              <div className="p-2 h-full flex flex-col">
                <div className="w-full aspect-[3/4] overflow-hidden">
                  {b.images && b.images[0] && (
                    <img
                      src={getOptimizedUrl(b.images[0] || '', 1200)}
                      alt={b.title}
                      className="w-full h-full object-cover"
                    />
                  )}
                </div>
                <div className="mt-3 flex flex-col flex-1">
                  <h3 className="text-2xl font-medium font-bdogrotesk text-black leading-tight">
                    {b.title}
                  </h3>
                  {b.subtitle && (
                    <div className="text-base text-black">{b.subtitle}</div>
                  )}
                  <div className="mt-2 min-h-[4.5rem]">
                    <p className="text-sm text-gray-500 line-clamp-3 overflow-hidden">
                      <span className="text-black">
                        {fmtDate(b.createdAt)}
                      </span>: {b.previewSnippet || b.intro || b.excerpt}
                    </p>
                  </div>

                  <div className="mt-auto pt-4">
                  <button
                    type="button"
                    onClick={() => navigate(`/blog/?blog=${b._id}`)}
                    style={{
                      border: "1px solid #000",
                      boxSizing: "border-box",
                      backgroundColor: "#fff",
                    }}
                    className="group mt-0 w-full text-black bg-white px-3 py-2 flex items-center justify-between text-[15px] font-semibold tracking-wide"
                  >
                    <div className="relative h-5 overflow-hidden flex-1">
                      <div className="relative flex flex-col transition-transform duration-300 ease-in-out group-hover:-translate-y-1/2">
                        <span className="flex h-5 text-base items-center">
                          Read More
                        </span>
                        <span className="flex h-5 text-base items-center">
                          Read More
                        </span>
                      </div>
                    </div>
                    <div className="relative h-5 overflow-hidden ml-4 flex-none">
                      <div className="relative flex flex-col transition-transform duration-300 ease-in-out group-hover:-translate-y-1/2">
                        <span className="flex h-5 items-center text-base text-black">
                          {(b.readingTime || 5) + ' min'}
                        </span>
                        <span className="flex h-5 items-center text-base text-black">
                          {(b.readingTime || 5) + ' min'}
                        </span>
                      </div>
                    </div>
                  </button>
                </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
    </div>
  );
};

export default Blogs;
